/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useRef, useEffect, useState } from "react";
import { Modal, Col, Row, Form } from "react-bootstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";

import { useMutation, useLazyQuery } from "@apollo/client";
import {
  Divider,
  TextField,
  Checkbox,
  InputAdornment,
  IconButton,
  Typography,
  Button,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
} from "@material-ui/core";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { Formik } from "formik";

import {
  setShowGuestSignupModal,
  setShowSignupModal,
  setShowLoginModal,
  setShowOptionPopper,
  setIsShowTNCDialog,
} from "../../../redux/layout/layoutActions";
import { useShowPassword } from "../../CustomHooks/useShowPassword";
import {
  MERGE_ORGANIZATION_REQUEST,
  MERGE_ORGANIZATION,
} from "../../GraphQlCommon/mutation";
import { USER_BY_ID } from "../../GraphQlCommon/query";
import * as auth from "../../Modules/Auth/_redux/authRedux";
import * as actions from "../../Pages/Assets/_redux/assetActions";
import {
  UPDATE_EMPLOYEE_APPROVE,
  UPDATE_EMPLOYEE_VERIFY_EMAIL_STATUS,
} from "../../Pages/Employees/graphQl/mutation";
import { GET_ORGANIZATIONS } from "../../Pages/Organizations/Graphql/query";
import { TncDialog } from "../../Pages/Selling/seller/screen/TncDialog";
import {
  ACTION_ASSET_LIST,
  countryCode,
  LOCAL_STORAGE_ROLES,
  NEGOTIATION_CALLING_ACTION,
  ROLE_BUYER,
  ROLE_GUEST,
  TOKEN,
} from "../../Utils/constant";
import { base64Decode, page360Url } from "../../Utils/helper";
import { DASHBOARD_PAGE } from "../../Utils/routePaths";
import { SectionLoader } from "../SectionLoader";

import { SIGNUP_NORMAL, UPDATE_NORMAL_USER } from "./mutation";
import { useSignupValidationSchema } from "./useSignupValidationSchema";

export const SignUp = props => {
  const { initialValues, signupValidationSchema } = useSignupValidationSchema();

  const { handleClose, action, asset } = props;

  const [checked, setChecked] = useState(false);

  const [error, setError] = useState(null);

  const {
    showPassword,
    toggleShowPassword,
    showConPassword,
    toggleShowConPassword,
  } = useShowPassword();

  const [modalOpen, setModalOpen] = useState(false);

  const [guest, setGuest] = useState(false);

  const [currency, setCurrency] = useState("+1");

  const [isOrganizationExist, setIsOrganizationExist] = useState(false);

  const [existingOrganization, setExistingOrganization] = useState(false);

  const [filterOrganization, setFilterOrganization] = useState();

  const [prevCurrentOrg, setPrevCurrentOrg] = useState();

  const [showMergeContentAlert, setShowMergeContentAlert] = useState(false);

  const [isReqOrgBuyer, setIsReqOrgBuyer] = useState(false);

  const [initialValState, setInitialVal] = useState(initialValues);

  const [tempObj, setTempObj] = useState(null);

  const [value, setValue] = useState();

  const [userData, setUserData] = useState();

  const [ID, setId] = useState(null);

  const [actionTmp, setActionTmp] = useState(false);

  const dispatch = useDispatch();

  const formikRef = useRef();

  const history = useHistory();

  const intl = useIntl();

  // Getting current state of layout from store (Redux)
  const { isShowTNCDialog } = useSelector(
    state => ({ isShowTNCDialog: state.layout.isShowTNCDialog }),
    shallowEqual,
  );

  const { showSignupModal } = useSelector(
    state => ({ showSignupModal: state.layout.showSignupModal }),
    shallowEqual,
  );

  const { showGuestSignupModal } = useSelector(
    state => ({ showGuestSignupModal: state.layout.showGuestSignupModal }),
    shallowEqual,
  );

  const { showOptionPopper } = useSelector(
    state => ({ showOptionPopper: state.layout.showOptionPopper }),
    shallowEqual,
  );

  const { loginAction } = useSelector(
    state => ({ loginAction: state.layout.loginAction }),
    shallowEqual,
  );

  // Getting current state of Auth from store (Redux)
  const { user } = useSelector(
    state => ({ user: state.auth.user }),
    shallowEqual,
  );

  useEffect(() => {
    const roles = JSON.parse(window.localStorage.getItem(LOCAL_STORAGE_ROLES));

    if (roles && roles[0] === ROLE_GUEST) {
      setGuest(true);
    } else {
      setGuest(false);
    }

    let ids;
    if (props.match !== undefined) {
      if (props.match.params) {
        const { id } = props.match.params;

        ids = base64Decode(id);
        setId(ids);
      }
    }

    if (ids) {
      setModalOpen(true);
    }

    if (tempObj) {
      setTempObj(null);
    }
  }, []);

  useEffect(() => {
    if (ID) {
      userDetailById({
        variables: {
          userId: ID,
        },
      });
    }
  }, [ID]);

  useEffect(() => {
    if (handleClose === null) {
      setModalOpen(true);
    }
  }, [handleClose]);

  useEffect(() => {
    if (action) setActionTmp(action);
    else {
      if (loginAction) setActionTmp(loginAction);
    }
  }, [props]);

  const [
    userDetailById,
    { loading: userLoading, error: currentUserError, data: currentUserData },
  ] = useLazyQuery(USER_BY_ID, {
    fetchPolicy: "no-cache",
  });

  const [
    userSignUp,
    { loading: guestLoading, error: guestError, data: guestData },
  ] = useMutation(SIGNUP_NORMAL);

  const [
    mergeOrg,
    { loading: mergeOrgLoading, error: mergeOrgError, data: mergeOrgData },
  ] = useMutation(MERGE_ORGANIZATION_REQUEST);

  const [
    mergeOrgFun,
    {
      loading: mergeOrgFunLoading,
      error: mergeOrgFunError,
      data: mergeOrgFunData,
    },
  ] = useMutation(MERGE_ORGANIZATION);

  const [
    getOrganizations,
    {
      loading: organizationsLoading,
      error: organizationsError,
      data: organizationsData,
    },
  ] = useLazyQuery(GET_ORGANIZATIONS, {
    fetchPolicy: "no-cache",
  });

  const [
    employeeApproveStatus,
    {
      loading: employeeApproveStatusLoading,
      error: employeeApproveStatusError,
      data: employeeApproveStatusData,
    },
  ] = useMutation(UPDATE_EMPLOYEE_APPROVE, {
    fetchPolicy: "no-cache",
  });

  const [
    userUpdate,
    { loading: updateUserLoading, error: updateUserError, data: updateUserData },
  ] = useMutation(UPDATE_NORMAL_USER);

  const [getEmployeeVerifyEmail] = useMutation(
    UPDATE_EMPLOYEE_VERIFY_EMAIL_STATUS,
    {
      onCompleted() {
        toast.success(intl.formatMessage({ id: "EMAIL.VERIFY.LINK.MESSAGE" }), {
          position: toast.POSITION.TOP_RIGHT,
        });
      },
    },
  );

  useEffect(() => {
    if (employeeApproveStatusError) {
      toast.error(employeeApproveStatusError?.message.toString(), {
        position: toast.POSITION.TOP_RIGHT,
      });
    }

    if (employeeApproveStatusData) {
      toast.success(intl.formatMessage({ id: "GLOBAL.ORG_REMOVE_TEXT" }), {
        position: toast.POSITION.TOP_RIGHT,
      });
      handleModelClose();
    }
  }, [employeeApproveStatusData, employeeApproveStatusError]);

  useEffect(() => {
    if (guestData) {
      let { user, token } = guestData.signUpForNormalUser;
      saveUserData(user, token);
      handleActionState();
      if (ID) {
        setShowMergeContentAlert(true);
      } else {
        handleModelClose();
      }

      setError(null);
    }

    if (guestError) {
      // setError(guestError.toString().replace("Error: Error:", ""));
      setError(guestError.networkError?.result?.errors[0]?.message?.toString());
    }
  }, [guestError, guestData]);

  useEffect(() => {
    if (tempObj) {
      setInitialVal(initialValues);
      setError(null);
    }
  }, [tempObj]);

  useEffect(() => {
    if (updateUserData) {
      let userTemp = updateUserData.updateNormalUser;
      if (
        user?.isUserVerified &&
        user?.roles.findIndex(val => val?.key === ROLE_GUEST) > -1
      ) {
        if (!isOrganizationExist) setIsOrganizationExist(true);
        setFilterOrganization(null);
        setShowMergeContentAlert(true);
      } else {
        handleModelClose();
        handleActionState();
      }

      getEmployeeVerifyEmail({
        variables: {
          email: userTemp.email,
        },
      });
      saveUserData(userTemp, null);
      setError(null);
    }

    if (updateUserError) {
      setError(updateUserError.toString().replace("Error: Error:", ""));
    }
  }, [updateUserError, updateUserData]);

  useEffect(() => {
    if (currentUserData) {
      const tempData = currentUserData.getUserById;

      setUserData(tempData);
    }

    if (currentUserError) {
      setError(currentUserError.toString().replace("Error: Error:", ""));
    }
  }, [currentUserData, currentUserError]);

  // merge org request useEffect
  useEffect(() => {
    if (mergeOrgData) {
      handleMergOrgSuccessScenerio();
    }

    if (mergeOrgError) {
      handleMergeOrgFailureScenerio();
    }
  }, [mergeOrgLoading, mergeOrgData, mergeOrgError]);

  useEffect(() => {
    if (user || userData) {
      setInitialVal(initialValues);
    }
  }, [user, userData]);

  const listOrganizations = () => {
    if (formikRef?.current?.values.comp_name) {
      if (existingOrganization) setExistingOrganization(null);
      if (filterOrganization) setFilterOrganization(null);
      getOrganizations({
        variables: {
          filter: {
            search: formikRef?.current?.values.comp_name,
            isJoinOrganization: true,
          },
        },
      });
    } else {
      if (existingOrganization) setExistingOrganization(null);
      if (filterOrganization) setFilterOrganization(null);
    }
  };

  //merge org useEffect
  useEffect(() => {
    if (mergeOrgFunData) {
      handleMergOrgSuccessScenerio();
    }

    if (mergeOrgFunError) {
      handleMergeOrgFailureScenerio();
    }
  }, [mergeOrgFunLoading, mergeOrgFunData, mergeOrgFunError]);

  useEffect(() => {
    if (organizationsData) {
      const { result, count } = organizationsData?.getAllOrganizations;

      if (count > 0) {
        var orgCount = 0;
        var orgData = [];

        for (var i = 0; i < result.length; i++) {
          if (
            result[i].name?.toLowerCase() ===
            formikRef?.current?.values.comp_name.toLowerCase()
          ) {
            orgCount++;
            orgData.push(result[i]);
          }
        }

        // check organization list to user Org list
        const user = JSON.parse(window.localStorage.getItem("user"));

        if (user && user?.userOrg && user?.userOrg?.length > 0) {
          if (orgCount > 0 && orgCount === 1) {
            for (var j = 0; j < user.userOrg.length; j++) {
              if (!user.userOrg[j].isDeleted) {
                if (user.userOrg[j].organization?.id === orgData[0].id) {
                  toast.error(
                    intl.formatMessage({
                      id: "ASSOCIATE.ORGANIZATION.ALERT",
                    }),
                    {
                      position: toast.POSITION.TOP_RIGHT,
                    },
                  );
                  formikRef &&
                    formikRef.current &&
                    formikRef.current.setFieldValue("comp_name", "");
                } else {
                  setExistingOrganization(orgData[0]);
                }
              }
            }
          }

          handleOrgScenrio(orgCount, orgData);
        } else {
          handleOrgScenrio(orgCount, orgData);
        }
      }
    }

    if (organizationsError)
      setError(organizationsError.toString().replace("Error: Error:", ""));
  }, [organizationsLoading, organizationsData, organizationsError]);

  const handleMergOrgSuccessScenerio = () => {
    if (ID) {
      setShowMergeContentAlert(false);
      history.push(DASHBOARD_PAGE);
      return;
    } else {
      handleModelClose();
    }

    setShowMergeContentAlert(false);
    handleActionState();
  };

  const handleMergeOrgFailureScenerio = () => {
    let error = mergeOrgError.toString().replace("Error: Error:", "");
    if (error === intl.formatMessage({ id: "GLOBAL.MERGE_NOT_SELLER_ERROR" })) {
      setShowMergeContentAlert(false);
      setIsReqOrgBuyer(true);
    } else setError(error);
  };

  const handleOrgScenrio = (orgCount, orgData) => {
    if (orgCount > 1) {
      setFilterOrganization(orgData);
    } else if (orgCount > 0 && orgCount === 1) {
      setExistingOrganization(orgData[0]);
    }
  };

  const handleActionState = () => {
    if (actionTmp) {
      if (actionTmp === "make-offer") {
        let tempVal = {
          action: "make-offer",
          isShown: true,
        };
        dispatch(actions.setOpenOfferModel(tempVal));
      } else if (actionTmp === "finance") {
        openFinanceTab();
      } else if (actionTmp === "wishlist") {
        dispatch(actions.addAssetInWishlist(true));
      } else if (actionTmp === "customlist") {
        dispatch(actions.addAssetInCustomList(true));
      } else if (actionTmp === "counter-offer" || actionTmp === "buy-now") {
        dispatch(actions.setIsSignupSuccessfull(true));
      } else if (actionTmp === ACTION_ASSET_LIST) {
        callAssetDetailPage();
      }
    }
  };

  const saveUserData = (user, token) => {
    if (token !== null) {
      window.localStorage.setItem(TOKEN, token);
      dispatch(auth.actions.login(token));
    }

    window.localStorage.setItem("user", JSON.stringify(user));
    const roles = user?.roles.map(role => role.key);

    window.localStorage.setItem(LOCAL_STORAGE_ROLES, JSON.stringify(roles));
    dispatch(
      auth.actions.fulfillUser({
        ...user,
      }),
    );
  };

  const handleModelClose = () => {
    if (modalOpen) {
      setModalOpen(false);
      dispatch(setShowSignupModal(false));
      if (showOptionPopper) dispatch(setShowOptionPopper(null));
      setIsOrganizationExist(false);
      setError(null);
    }

    dispatch(setShowGuestSignupModal(false));
    dispatch(setShowLoginModal(false));
    dispatch(setShowSignupModal(false));
    dispatch(setShowOptionPopper(null));
    setTempObj(null);
    setInitialVal(initialValues);
  };

  const openFinanceTab = () => {
    dispatch(actions.setTab({ tabNo: 2, tabName: "finance" }));
  };

  const handleClickOpen = () => {
    dispatch(setIsShowTNCDialog(true));
  };

  const callAssetDetailPage = () => {
    history.push({
      pathname: page360Url(asset),
      state: NEGOTIATION_CALLING_ACTION,
    });
    if (showOptionPopper) dispatch(setShowOptionPopper(null));
  };

  const handleCurrencyChange = event => {
    setCurrency(event.target.value);
  };

  const handleExistingSubmit = isCreateNew => {
    if (existingOrganization) {
      if (isCreateNew) {
        if (user) {
          userUpdate({
            variables: {
              email: tempObj?.email,
              phoneno: tempObj?.phoneno,
              password: tempObj?.password,
              name: tempObj?.name,
              organizationName: tempObj?.organizationName,
            },
          });
        } else {
          userSignUp({
            variables: {
              email: tempObj?.email,
              phoneno: tempObj?.phoneno,
              password: tempObj?.password,
              name: tempObj?.name,
              organizationName: tempObj?.organizationName,
              roleKey: ROLE_BUYER,
            },
          });
        }
      } else {
        if (user) {
          userUpdate({
            variables: {
              email: tempObj?.email,
              phoneno: tempObj?.phoneno,
              password: tempObj?.password,
              name: tempObj?.name,
              organizationId: existingOrganization
                ? existingOrganization.id
                : "",
            },
          });
        } else {
          userSignUp({
            variables: {
              email: tempObj?.email,
              phoneno: tempObj?.phoneno,
              password: tempObj?.password,
              name: tempObj?.name,
              organizationId: existingOrganization
                ? existingOrganization.id
                : "",
              roleKey: ROLE_BUYER,
            },
          }).catch(() => { });
        }
      }

      setPrevCurrentOrg(user?.currentOrganization?.id);
    } else {
      if (filterOrganization) {
        toast.error(intl.formatMessage({ id: "ERROR.SELECT.ORGANIZATION" }), {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };

  const showLocationWithOrg = item => {
    if (item?.locations && item.locations?.length > 0) {
      return `${item.name} (${item.locations[0].cityName},${item.locations[0].stateName})`;
    } else {
      return `${item.name}`;
    }
  };

  const handleYesSubmit = () => {
    const user = JSON.parse(window.localStorage.getItem("user"));

    if (user) {
      if (!guest) {
        mergeOrg({
          variables: {
            orgId: prevCurrentOrg || user?.currentOrganization?.id,
            userId: user?.id || "",
            mergeOrgId:
              existingOrganization?.id || user?.currentOrganization?.id,
          },
        });
      } else {
        if (existingOrganization?.id) {
          mergeOrg({
            variables: {
              orgId: prevCurrentOrg || "",
              userId: user?.id || "",
              mergeOrgId:
                existingOrganization?.id || user?.currentOrganization?.id,
            },
          });
        } else {
          mergeOrgFun({
            variables: {
              orgId: prevCurrentOrg || "",
              mergeOrgId: user?.currentOrganization?.id,
              userId: user?.id || "",
            },
          });
        }
      }
    }
  };

  const handleNoSubmit = () => {
    if (ID) {
      setShowMergeContentAlert(false);
      history.push(DASHBOARD_PAGE);
    } else {
      handleModelClose();
    }
  };

  const renderExistingLayout = () => {
    if (showMergeContentAlert) {
      return (
        <>
          <Typography>
            Do you wish to merge your existing individual data into the new
            organization?
          </Typography>
          <br />
          <br />

          <Typography>
            <b>Note:</b> Merging data into the new organization will have
            followning impact-
            <br />
            <br />
            <ul>
              <li>
                Your individual notes & list will be moved to private notes
              </li>
              <li>
                If you are doing a negotiation on an asset on which the company
                is already negotiating, all your deals & conversation specific
                to that asset will be lost
              </li>
            </ul>
          </Typography>
        </>
      );
    } else if (isReqOrgBuyer) {
      return (
        <>
          <Typography>
            <FormattedMessage id="GLOBAL.MERGE_NOT_SELLER_ERROR" />
            <br />
            <br />
          </Typography>
        </>
      );
    } else if (filterOrganization) {
      const OrgData = filterOrganization;

      const filteredOrgLocList = [];

      for (let i = 0; i < OrgData.length; i++) {
        let primaryLoc = OrgData[i].locations;

        if (primaryLoc.length > 0) {
          for (let j = 0; j < primaryLoc.length; j++) {
            if (primaryLoc[j].isPrimary === true) {
              filteredOrgLocList.push(OrgData[i]);
            }
          }
        } else {
          filteredOrgLocList.push(OrgData[i]);
        }
      }

      return (
        <>
          <Typography>
            {
              "There are multiple Companies in our system with the Company Name you have chosen. You can join one of these organization & click the \"Join Organization\" button. You'll then be verified by the Company Admin. If you do not want to join the existing organization, please click on \"Create New Organization\" button."
            }
          </Typography>
          <FormControl component="fieldset">
            <RadioGroup
              aria-label="org"
              name="org"
              value={value}
              onChange={handleChange}
            >
              <div>
                {filteredOrgLocList.map((item, index) => {
                  return (
                    <FormControlLabel
                      id={index}
                      value={item.id}
                      control={<Radio />}
                      label={showLocationWithOrg(item)}
                    />
                  );
                })}
              </div>
            </RadioGroup>
          </FormControl>
        </>
      );
    } else if (existingOrganization) {
      return (
        <div className="mb-10">
          <Typography>
            {`${tempObj?.organizationName} Company Name exists in our system. You can join this organization by clicking "Join Organization" button. You'll then be verified by the Company Admin. If you do not want to join the existing organization, please click on "Create New Organization" button. `}
          </Typography>
        </div>
      );
    }
  };

  const handleChange = event => {
    setValue(event.target.value);
    setExistingOrganization({ id: event.target.value });
  };

  const deleteOrg = () => {
    const userOrgObj = user.userOrg.find(
      x => x.organization.id === user.currentOrganization.id,
    );

    employeeApproveStatus({
      variables: {
        userId: user.id,
        isUserVerified: false,
        userOrganizationId: userOrgObj?.id,
        organizationId: user?.currentOrganization?.id,
      },
    });
  };

  const handleOrgBuyerButtonLayout = () => {
    return (
      <>
        <button
          type="button"
          onClick={handleModelClose}
          className="btn btn-primary btn-elevate mt-5"
        >
          {intl.formatMessage({
            id: "GLOBAL.CONTINUE",
          })}
        </button>
        <button
          type="button"
          onClick={deleteOrg}
          className="btn btn-primary btn-elevate mt-5"
        >
          {intl.formatMessage({
            id: "GLOBAL.CANCEL_JOIN_REQUEST",
          })}
        </button>
      </>
    );
  };

  const handleCheckBoxChange = event => {
    setChecked(event.target.checked);
  };

  const handleBack = () => {
    setIsOrganizationExist(false);
    if (error) setError(null);
  };

  const renderLayoutBody = () => {
    return (
      <>
        {error && (
          <div className="mb-10 alert alert-custom alert-light-danger alert-dismissible">
            <div className="alert-text font-weight-bold">{error || "Error"}</div>
          </div>
        )}
        {!isOrganizationExist && !showMergeContentAlert && !isReqOrgBuyer ? (
          <>
            <Formik
              innerRef={formikRef}
              enableReinitialize={true}
              initialValues={initialValState}
              validationSchema={signupValidationSchema}
              onSubmit={(values, { setSubmitting }) => {
                if (checked) {
                  if (!existingOrganization && !filterOrganization) {
                    if (user) {
                      setPrevCurrentOrg(user?.currentOrganization?.id);

                      if (values.comp_name) {
                        userUpdate({
                          variables: {
                            email: values.email,
                            phoneno: values.phone,
                            password: values.password,
                            name: values.name,
                            organizationName: values.comp_name,
                          },
                        }).catch(() => { });
                      } else {
                        userUpdate({
                          variables: {
                            email: values.email,
                            phoneno: values.phone,
                            password: values.password,
                            name: values.name,
                          },
                        }).catch(() => { });
                      }
                    } else {
                      userSignUp({
                        variables: {
                          name: values.name,
                          email: values.email,
                          phoneno: values.phone,
                          password: values.password,
                          organizationName: values.comp_name,
                        },
                      }).catch(() => { });
                    }
                  } else {
                    setIsOrganizationExist(true);
                    setTempObj({
                      name: values.name,
                      email: values.email,
                      phoneno: values.phone,
                      password: values.password,
                      organizationName: values.comp_name,
                      changepassword: values.changepassword,
                    });
                  }
                } else {
                  toast.error("Please accept Term and condition", {
                    position: toast.POSITION.TOP_RIGHT,
                  });
                  setSubmitting(false);
                }
              }}
            >
              {({ handleSubmit, handleChange, values, errors, touched }) => (
                <>
                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <font color="red">* </font>
                        <Form.Label>
                          <FormattedMessage id="USER.FULL_NAME" />
                        </Form.Label>
                        <TextField
                          name="name"
                          fullWidth
                          variant="outlined"
                          value={values.name}
                          error={Boolean(errors.name)}
                          helperText={errors.name ? errors.name : ""}
                          onChange={e => {
                            handleChange(e);
                            if (error) setError(null);
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>
                          <font color="red">* </font>
                          <FormattedMessage id="GLOBAL.MOBILE" />
                        </Form.Label>
                        <div className="selectAndInputField countryCodeField">
                          <TextField
                            id="standard-select-selling-currency"
                            select
                            value={currency}
                            onChange={handleCurrencyChange}
                            SelectProps={{
                              native: true,
                            }}
                          >
                            {countryCode.map(option => (
                              <option key={option.label} value={option.label}>
                                {option.label}
                              </option>
                            ))}
                          </TextField>{" "}
                          <TextField
                            name="phone"
                            placeholder="###-###-####"
                            fullWidth
                            variant="outlined"
                            value={values.phone}
                            error={touched.phone && Boolean(errors.phone)}
                            helperText={touched.phone ? errors.phone : ""}
                            onChange={e => {
                              handleChange(e);
                              if (error) setError(null);
                            }}
                          />
                        </div>
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <font color="red">* </font>
                        <Form.Label>
                          <FormattedMessage id="AUTH.EMAIL" />
                        </Form.Label>
                        <TextField
                          name="email"
                          fullWidth
                          variant="outlined"
                          value={values.email}
                          error={touched.email && Boolean(errors.email)}
                          helperText={touched.email ? errors.email : ""}
                          onChange={e => {
                            handleChange(e);
                            if (error) setError(null);
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>

                  <Row>
                    <Col md="12">
                      <Form.Group>
                        <Form.Label>Company Name (Optional)</Form.Label>
                        <TextField
                          name="comp_name"
                          fullWidth
                          variant="outlined"
                          value={values.comp_name}
                          error={touched.comp_name && Boolean(errors.comp_name)}
                          helperText={touched.comp_name ? errors.comp_name : ""}
                          onChange={e => {
                            handleChange(e);
                            if (error) setError(null);
                          }}
                          onBlur={listOrganizations}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="6">
                      <Form.Group>
                        <font color="red">* </font>
                        <Form.Label>
                          <FormattedMessage id="AUTH.INPUT.PASSWORD" />
                        </Form.Label>{" "}
                        <TextField
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={toggleShowPassword} edge="end">
                                  {showPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          type={showPassword ? "text" : "password"}
                          name="password"
                          autoComplete="new-password"
                          fullWidth
                          variant="outlined"
                          value={values.password}
                          error={touched.password && Boolean(errors.password)}
                          helperText={touched.password ? errors.password : ""}
                          onChange={e => {
                            handleChange(e);
                            if (error) setError(null);
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col md="6">
                      <Form.Group>
                        <font color="red">* </font>
                        <Form.Label>
                          <FormattedMessage id="AUTH.INPUT.CONFIRM_PASSWORD" />
                        </Form.Label>{" "}
                        <TextField
                          InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton
                                  onClick={toggleShowConPassword}
                                  edge="end"
                                >
                                  {showConPassword ? (
                                    <Visibility />
                                  ) : (
                                    <VisibilityOff />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            ),
                          }}
                          type={showConPassword ? "text" : "password"}
                          name="changepassword"
                          fullWidth
                          variant="outlined"
                          value={values.changepassword}
                          error={
                            touched.changepassword &&
                            Boolean(errors.changepassword)
                          }
                          helperText={
                            touched.changepassword ? errors.changepassword : ""
                          }
                          onChange={e => {
                            handleChange(e);
                            if (error) setError(null);
                          }}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12">
                      <Form.Group className="termsCheckBox">
                        <Checkbox
                          checked={checked}
                          onChange={handleCheckBoxChange}
                          inputProps={{
                            "aria-label": "primary checkbox",
                          }}
                        />
                        <span onClick={handleClickOpen}>
                          I understand that by submitting any offers, I agree to
                          purchasing the asset, if offer is accepted, and agree
                          to all
                          <a>
                            <u> terms and conditions.</u>
                          </a>
                        </span>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col md="12" className="customModalFooter">
                      <Modal.Footer>
                        <Button
                          type="submit"
                          onClick={handleSubmit}
                          className="btn btn-primary btn-elevate"
                        >
                          Submit
                        </Button>

                        <Button
                          type="button"
                          onClick={handleModelClose}
                          className="btn btn-light btn-elevate"
                        >
                          Cancel
                        </Button>
                      </Modal.Footer>
                    </Col>
                  </Row>
                </>
              )}
            </Formik>
            <Divider light />
            <div className="b-15 mb-lg-0 mt-3 flex-column-auto pb-10 mt-5 text-center">
              <span className="font-weight-bold text-black mr-2">
                Already have an account?
              </span>
              <a
                className="text-blue-two"
                onClick={() => {
                  dispatch(setShowLoginModal(true));
                  if (showGuestSignupModal)
                    dispatch(setShowGuestSignupModal(false));
                  if (showSignupModal) dispatch(setShowSignupModal(false));
                }}
              >
                <u>
                  <FormattedMessage id="AUTH.LOGIN.POPUP_BUTTON" />
                </u>
              </a>
            </div>
          </>
        ) : (
          <div>
            {renderExistingLayout()}
            <Row>
              <Col md="12" className="customModalFooter">
                <Modal.Footer>
                  {showMergeContentAlert ? (
                    <>
                      <Button
                        type="button"
                        onClick={handleYesSubmit}
                        className="btn btn-primary btn-elevate"
                      >
                        Yes
                      </Button>
                      <Button
                        type="button"
                        onClick={handleNoSubmit}
                        className="btn btn-primary btn-elevate"
                      >
                        No
                      </Button>
                    </>
                  ) : !isReqOrgBuyer ? (
                    <>
                      <Button
                        type="submit"
                        onClick={handleBack}
                        className="btn btn-primary btn-elevate"
                      >
                        Go Back
                      </Button>
                      <Button
                        type="submit"
                        onClick={() => {
                          handleExistingSubmit(false);
                        }}
                        className="btn btn-primary btn-elevate"
                      >
                        <FormattedMessage id="GLOBAL.JOIN.ORG" />
                      </Button>
                      <Button
                        type="submit"
                        onClick={() => {
                          handleExistingSubmit(true);
                        }}
                        className="btn btn-primary btn-elevate mt-5"
                      >
                        <FormattedMessage id="GLOBAL.CREATE.NEW.ORG" />
                      </Button>
                    </>
                  ) : (
                    handleOrgBuyerButtonLayout()
                  )}
                </Modal.Footer>
              </Col>
            </Row>
          </div>
        )}
      </>
    );
  };

  return (
    <>
      <SectionLoader
        loader={
          guestLoading ||
          updateUserLoading ||
          organizationsLoading ||
          userLoading ||
          mergeOrgLoading ||
          mergeOrgFunLoading ||
          employeeApproveStatusLoading
        }
      />
      {!modalOpen ? (
        <>
          {guest && !showMergeContentAlert && !isOrganizationExist ? (
            <h4
              className="mb-7 font-weight-bolder"
              style={{ marginTop: "-55px" }}
            >
              <FormattedMessage id="GLOBAL.GUEST_SIGNUP" />
            </h4>
          ) : (
            <h4
              className="mb-7 font-weight-bolder"
              style={{ marginTop: "-55px" }}
            >
              <FormattedMessage id="GLOBAL.SIGN_UP" />
            </h4>
          )}
          {renderLayoutBody()}
        </>
      ) : (
        <Modal
          size="md"
          show={modalOpen}
          onHide={handleModelClose}
          aria-labelledby="example-modal-sizes-title-lg"
          centered
          backdrop="static"
        >
          {ID && !showMergeContentAlert ? (
            <Modal.Header closeButton>
              <Modal.Title>
                <FormattedMessage id="GLOBAL.GUEST_SIGNUP" />
              </Modal.Title>
            </Modal.Header>
          ) : (
            <Modal.Header closeButton>
              <Modal.Title>Sign Up</Modal.Title>
            </Modal.Header>
          )}

          <Modal.Body>{renderLayoutBody()}</Modal.Body>
        </Modal>
      )}
      {isShowTNCDialog && <TncDialog />}
    </>
  );
};
